export class DeviceAppVersionModel
{
  packageName: string='';
  appName: string='';
  appLogo: string='';
  appLogoPathUrl: string='';
  extention: string='';
  applicationId: string='';
  versionName: string='';
  versionCode: string='';
  buildNumber: string='';
  isRequired: boolean= false;
  versionInfo: string='';
  linkAndroid: string='';
  linkApple: string='';
  linkWebSite: string='';
  dateCreated: string='';
}

export enum DeviceAppVersionTextField
{
  title= 'Device App Version',
  packageName= 'Package Name',
  appName= 'App Name',
  appLogo= 'App Logo',
  appLogoPathUrl= 'App Logo PathUrl',
  applicationId= 'ApplicationId',
  versionName= 'VersionName',
  versionCode='VersionCode',
  buildNumber= 'BuildNumber',
  isRequired='IsRequired',
  versionInfo='VersionInfo',
  linkAndroid='LinkAndroid',
  linkApple='LinkApple',
  linkWebSite='LinkWebSite',
  dateCreated='Date Created',
}
